import React, { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import { AdjustAgencies } from 'scenes/Influencers/MasterCampaigns/components/MasterCampaignDetails/Agencies/AdjustAgencies';
import { AppsFlyerAgencies } from 'scenes/Influencers/MasterCampaigns/components/MasterCampaignDetails/Agencies/AppsFlyerAgencies';
import { MyTrackerAgencies } from 'scenes/Influencers/MasterCampaigns/components/MasterCampaignDetails/Agencies/MyTrackerAgencies';
import {
  ADJUST_PROVIDER,
  APPS_FLYER_PROVIDER,
  MY_TRACKER_PROVIDER,
} from 'scenes/Influencers/MasterCampaigns/constants';

const Agencies = ({ agencies = [], attributionProviderId }) => {
  const Agency = useMemo(() => {
    switch (attributionProviderId) {
      case ADJUST_PROVIDER:
        return AdjustAgencies;
      case APPS_FLYER_PROVIDER:
        return AppsFlyerAgencies;
      case MY_TRACKER_PROVIDER:
        return MyTrackerAgencies;
      default:
        return () => null;
    }
  }, [attributionProviderId]);

  if (isEmpty(agencies)) {
    return null;
  }

  return <Agency agencies={agencies} />;
};

export default Agencies;
